<template>
  <div>
    <b-container
      fluid
      :class="backgroundClass"
      class="px-0 mx-0 sectionImage__container"
    >
      <b-container class="d-flex align-items-center sectionImage">
        <b-container
          class="sectionImage--gap"
          :class="{ 'order-1': imageOrder }"
        >
          <b-row>
            <b-col cols="12">
              <img
                :src="`${image.filename}/m/1000x1000/smart`"
                alt=""
                class="img-fluid sectionImage__image"
                :class="{'sectionImage__image--color': colorImage}"
              >
            </b-col>
          </b-row>
        </b-container>
        <b-container>
          <b-row>
            <b-col cols="12">
              <div
                :class="textClass"
                class="sectionImage__content"
              >
                <h1 :class="textClass">
                  {{ title }}
                </h1>
                <div v-html="bodyHtml" />
                <b-button
                  v-if="buttonPrimary"
                  :href="buttonPrimaryTo"
                  :variant="textClass === 'text-dark' ? 'outline-dark' : 'outline-light'"
                  class="mr-2"
                >
                  {{ buttonPrimaryTitle }}
                </b-button>
                <b-button
                  v-if="buttonSecondary"
                  :href="buttonSecondaryHref"
                  variant="secondary"
                >
                  {{ buttonSecondaryTitle }}
                </b-button>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </b-container>
  </div>
</template>

<script>
import RichTextResolver from 'storyblok-js-client/dist/rich-text-resolver.es'

export default {
  name : 'SectionImage',
  props: {
    variant: {
      type   : String,
      default: '',
    },
    image: {
      type    : Object,
      required: true,
    },
    colorImage: {
      type   : Boolean,
      default: false,
    },
    imagePosition: {
      type   : String,
      default: '',
    },
    title: {
      type   : String,
      default: '',
    },
    content: {
      type   : String,
      default: '',
    },
    body         : { type: Object },
    buttonPrimary: {
      type   : Boolean,
      default: false,
    },
    buttonSecondary: {
      type   : Boolean,
      default: false,
    },
    buttonPrimaryTitle: {
      type   : String,
      default: null,
    },
    buttonPrimaryTo: {
      type   : String,
      default: null,
    },
    buttonSecondaryTitle: {
      type   : String,
      default: null,
    },
    buttonSecondaryTo: {
      type   : String,
      default: null,
    },
  },
  computed: {
    backgroundClass () {
      return `bg-${this.variant}`
    },
    imageOrder () {
      if (this.imagePosition === 'right') return true
      return false
    },
    textClass () {
      let className = ''
      switch (this.variant) {
        case 'primary':
          className = 'text-light'
          break
        case 'secondary':
          className = 'text-dark'
          break
        case 'light':
          className = 'text-dark'
          break
        case 'dark':
          className = 'text-light'
          break
      }
      return className
    },
    bodyHtml () {
      const resolver = new RichTextResolver()
      return resolver.render(this.body)
    },
  },
}
</script>

<style lang="scss" scoped>
.sectionImage {
  &__container {
    @include media-breakpoint-only(md) {
      padding-top: $spacer * 3;
      padding-bottom: $spacer * 3;
    }
    @include media-breakpoint-up(lg) {
      padding-top: $spacer * 4;
      padding-bottom: $spacer * 4;
    }
  }
  @include media-breakpoint-down(sm) {
    margin: 0;
    padding: 0;
    min-width: 100%;
    flex-wrap: wrap;
  }
  &--gap {
    margin: 0;
    padding: 0;
    @include media-breakpoint-down(sm) {
      min-width: 100%;
    }
    @include media-breakpoint-up(md) {
      flex-wrap: nowrap;
    }
  }
  &__image {
    margin-bottom: $spacer * 2;
    filter: grayscale(100%) contrast(120%);

    &--color {
      filter: unset;
    }

    @include media-breakpoint-up(md) {
      height: 20em;
      width: 20em;
      border: $border-width solid $primary;
    }

    @include media-breakpoint-only(lg) {
      height: 24em;
      width: 24em;
    }

    @include media-breakpoint-up(xl) {
      height: 26em;
      width: 26em;
    }
  }
  &__content {
    margin-bottom: $spacer * 2;
  }
}
</style>
